import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/performance";
import "firebase/analytics";

const prodConfig = {
  apiKey: "AIzaSyC_f6PxxbWdBwc1-2LgJUt97a3Qu7-WtKU",
  authDomain: "aurum-fitness.firebaseapp.com",
  projectId: "aurum-fitness",
  storageBucket: "aurum-fitness.appspot.com",
  messagingSenderId: "858704491641",
  appId: "1:858704491641:web:622ed995b6aa1b9d4f50a8",
  measurementId: "G-MC1YFRJ8N4"
};

const devConfig = {
  apiKey: "AIzaSyC_f6PxxbWdBwc1-2LgJUt97a3Qu7-WtKU",
  authDomain: "aurum-fitness.firebaseapp.com",
  projectId: "aurum-fitness",
  storageBucket: "aurum-fitness.appspot.com",
  messagingSenderId: "858704491641",
  appId: "1:858704491641:web:622ed995b6aa1b9d4f50a8",
  measurementId: "G-MC1YFRJ8N4"
};

const config = process.env.NODE_ENV === "production" ? prodConfig : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config)
  firebase.analytics();
}

const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
const perf = firebase.performance();


export { db, auth, storage };
